/**
 * Copyright (c) [2024] Jangouts
 *
 * This software may be modified and distributed under the terms
 * of the MIT license.  See the LICENSE.txt file for details.
 */

import React, { useState, useEffect } from "react";
import { Phone, PhoneOff, MoreVertical } from "react-feather";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import janusApi from "../../janus-api";
import { actionCreators as roomActions } from "../../state/ducks/room";
import { actionCreators as callActions } from "../../state/ducks/call";
import { CONTACT_STATES } from "../../state/ducks/call";
import { apiCreateCallLog } from "../../api/CallLog";
import { useToastContext } from "../../components/Toast";

const statusColors = {
  [CONTACT_STATES.ONLINE]: "status-online",
  [CONTACT_STATES.OFFLINE]: "status-offline",
  [CONTACT_STATES.BUSY]: "status-busy",
  [CONTACT_STATES.AWAY]: "status-offline",
};

const statusLabels = {
  [CONTACT_STATES.ONLINE]: "在线",
  [CONTACT_STATES.OFFLINE]: "离线",
  [CONTACT_STATES.BUSY]: "忙碌",
  [CONTACT_STATES.AWAY]: "离开",
};

function ContactItem({ contact }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const userInfo = useSelector((state) => state.user.userInfo);
  const { settings, error } = useSelector((state) => state.room);
  const toast = useToastContext();
  const [autoCallTriggered, setAutoCallTriggered] = useState(false);

  // 自动呼叫逻辑
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const toUserParam = searchParams.get('toUser');
    if (toUserParam && parseInt(toUserParam) > 0) {
      const toUserId = parseInt(toUserParam);
      // 比较 contact.id 与 toUserId，注意类型转换
      if (contact.id == toUserId && !autoCallTriggered) {
        console.log(`检测到自动呼叫参数 toUser=${toUserId}，匹配当前联系人 ${contact.id}，开始自动呼叫`);
        setAutoCallTriggered(true);
        handleCallClick();
      }
    }
  }, [location.search, contact.id, autoCallTriggered]);

  const handleCallClick = async () => {
    if (!isCallable) {
      console.log("Contact is not available for calling");
      return;
    }

    // 生成一个随机的通话ID
    const callId = `call_${Date.now()}_${Math.random()
      .toString(36)
      .substr(2, 9)}`;

    console.log(
      `Initiating call to ${contact.name} (${contact.id}) with callId: ${callId}`,
    );

    try {
      // 创建房间
      const roomId = Math.floor(10000 + Math.random() * 90000);
      const requestData = {
        request: "create",
        room: roomId,
        publishers: 2, // 最多2个发布者（一对一）
        bitrate: 128000, // 音频比特率
        permanent: true, // 永久房间
      };
      const roomRes = await janusApi.createRoom(requestData);
      if (roomRes.videoroom === "created") {
        let data = {
          callId,
          roomId: String(roomId),
          acceptorId: contact.id,
          callStatus: 0,
        };
        // 需要修改的地方
        // 加入房间
        // const res = await janusApi.enterRoom(
        //   { id: roomId },
        //   userInfo.nickname,
        //   "",
        // );
        const newSettings = {
          ...settings,
          username: userInfo.nickname,
          roomId: roomId,
        };
        dispatch(roomActions.saveSettings(newSettings));
        dispatch(roomActions.login(userInfo.nickname, roomId));

        // if (res) {
        //   await apiCreateCallLog(data);
        // }
        const rlog = await apiCreateCallLog(data);
        console.log("callId====", rlog.data);
      } else {
        toast.error("呼叫失败，请稍后再试", { duration: 1500 });
        return;
      }
      // 先更新Redux状态为呼出状态
      dispatch(
        callActions.initiateCall(
          contact.id,
          contact.name,
          callId,
          roomId,
          true,
        ),
      );
      // 弹出通话窗口
      //dispatch(callActions.callActive(callId));

      // 调用Janus API实际发起呼叫
      // 注意：这里需要当前用户的用户名，暂时用随机生成
      // const currentUsername = `user_${Date.now()
      //   .toString()
      //   .slice(-4)}`;
      // const callInfo = await janusApi.initiateCall(contact.id, contact.name, callId);

      // console.log('Call initiated successfully:', callInfo);

      // 如果呼叫成功，call-service会自动发送信令并更新状态
      // 如果呼叫失败，需要更新状态为失败
    } catch (error) {
      console.error("Failed to initiate call:", error);
      // 可以添加错误处理，比如显示通知
      // dispatch(callActions.callFailed(callId, error.message));
    }
  };


  const isCallable = contact.status === CONTACT_STATES.ONLINE;

  return (
    <>
      <div className="contact-card p-4 flex items-center justify-between">
        <div className="flex items-center">
          <div className="relative">
            <div className="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center text-white font-semibold uppercase">
              {contact.name.charAt(0)}
            </div>
            <span
              className={`${statusColors[contact.status]} absolute bottom-0 right-0 border-2 border-white`}
            ></span>
          </div>
          <div className="ml-3">
            <h3 className="font-medium">{contact.name}</h3>
            <p className="text-sm text-blue-200">{statusLabels[contact.status]}</p>
          </div>
        </div>
        <button onClick={handleCallClick} className={`call-btn w-10 h-10 rounded-full flex items-center justify-center
          ${
              isCallable
                ? "text-white"
                : "text-gray-400 cursor-not-allowed"
            }`}>
          {isCallable ? <Phone size={18} /> : <PhoneOff size={18} />}
        </button>
      </div>
      
    </>
  );
}

export default ContactItem;
